// cookie.web.js

import cookie from "cookie";

export default {
  clearAll: async ()=>{
    const _cookies = cookie.parse(document.cookie);
    Object.keys(_cookies).forEach((cookieName)=>{
      document.cookie = `${cookieName}=; expires=-99999; path=/; domain=${window.main.api.cookieDomain}`;
    });
  },
  getAll: async ()=>{
    return cookie.parse(document.cookie);
  },
};
